import { render, staticRenderFns } from "./awareness.vue?vue&type=template&id=1428ec0f&"
import script from "./awareness.vue?vue&type=script&lang=js&"
export * from "./awareness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports